module.exports = __webpack_public_path__ + "img/Support-skill-223.2fec8708.png";